import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { ADD_NEW_GUEST, REMOVE_GUEST, SET_GUEST_MAIL_ERROR, SET_GUEST_MOBILE_ERROR, SET_GUEST_NAME_ERROR, resetGuest } from '../ducks/GuestsDucks';
import { resize } from '../ducks/ApplicationDucks';

function* addGuest() {
  yield put(resize());
}

function* removeGuest() {
  yield put(resize());
}

function* addGuestSagas() {
  yield takeEvery(ADD_NEW_GUEST, addGuest);
}

function* removeGuestSagas(){
  yield takeEvery(REMOVE_GUEST, removeGuest);
}

function* resetGuestSaga({ guestIndex }) {
  yield put(resetGuest(guestIndex));
}

function* setGuestMailError() {
  yield takeEvery(SET_GUEST_MAIL_ERROR, resetGuestSaga);
}
function* setGuestMobileError() {
  yield takeEvery(SET_GUEST_MOBILE_ERROR, resetGuestSaga);
}
function* setGuestNameError() {
  yield takeEvery(SET_GUEST_NAME_ERROR, resetGuestSaga);
}

export default function* () {
  yield all([
    fork(addGuestSagas),
    fork(removeGuestSagas),
    fork(setGuestMailError),
    fork(setGuestMobileError),
    fork(setGuestNameError)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/GuestsSagas.js